import { render, staticRenderFns } from "./EditLavReport.vue?vue&type=template&id=7836b539"
import script from "./EditLavReport.vue?vue&type=script&lang=js"
export * from "./EditLavReport.vue?vue&type=script&lang=js"
import style0 from "./EditLavReport.vue?vue&type=style&index=0&id=7836b539&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports